/***************************************************************************/
"use client";
/***************************************************************************/

import { TLanguage } from "@/universal/types/user-preferences";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./i18-next";

const I18NextProvider: React.FC<{
  children: React.ReactNode;
  language?: TLanguage;
}> = ({ children, language }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const t = setTimeout(() => {
      if (i18n.isInitialized && language !== i18n.language) {
        i18n.changeLanguage(language);
      }
    }, 500);

    return () => clearTimeout(t);
  }, [language, i18n.isInitialized, i18n.language]);

  return i18n.isInitialized ? children : null;
};

export default I18NextProvider;
